import type { FaireProductEntity } from "../../entity_types/product";

export const p_9np483v8t9: FaireProductEntity = {
  token: "p_9np483v8t9",
  type: "product",
  name: "Mancala, Fruit",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/b342b806f966d67100e96eca0a3bdcec6fae7fd7cd995fac01dbdcf0b50a87ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf5820223da0bae9b4260ff722e7869ff600886eebd7139e66790a3a9315a96a.jpeg",
    "https://cdn.faire.com/fastly/4ccbc7e607af0aeab2e2923d4b948e52c54cddb2ca9d26e92ee3c18326367b3e.jpeg",
    "https://cdn.faire.com/fastly/e25811c00ce4690fa0d9c0a1761c93f7a88cda35f52170495c4c15fc87422e42.jpeg",
    "https://cdn.faire.com/fastly/0425b9f05dac77e4db5bda9aa397df73cb1a6e77fb82be30053e99d513d8c2a2.jpeg",
    "https://cdn.faire.com/fastly/b3fb4f2abbf35ad0db2fc9c745eaaa37224f24834c7ef01a17e889d9af2478c8.jpeg",
    "https://cdn.faire.com/fastly/54d4860f8305f8ad2f9b69fe35db32cc4bfd048422dd853d309c66a8ef40f592.jpeg"
  ],
  priceDollars: 16.5,
  description: "Mancala is the name of the game — and we’ve put a picnic spin on it! This ban.do mancala set comes with a foldable board and 48 adorable fruit-shaped pieces, making it a bright, playful twist on a classic. Easy to pack, easy to play, and perfect for adding a little fun to your next picnic or game night.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Includes a foldable game board and 48 fruit-shaped pieces\n• A colorful, modern take on the classic mancala game\n• Compact and portable for picnics, travel, or at-home fun\n• Great for all ages and easy to learn\n• Designed in ban.do’s signature bright and joyful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and toy boutiques\n• Lifestyle retailers and game collections\n• Family game nights, picnics, and travel sets\n• Wholesale buyers seeking fun, design-forward games",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:16.049Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
